export const Error_No_Attachment = Error('file.noAttachment')
export const Error_No_File = Error('file.noFile')
export const Error_No_Response = Error('file.noResponsed')
export const Error_No_Signed_URL = Error('file.noSignedUrl')
